const pow2 = (obj) => obj * obj;
export default pow2;
